import React from 'react';

function AnswerOption(props) {
    const divStyle = {
        whiteSpace: "normal"

    };
    return (
    <div>
    <div className="radio radio-custom col-lg-3">
        <li className="list-unstyled">
        <label className="btn btn-default waves-effect w-md btn-lg btn-block"  style={divStyle} htmlFor={props.answerType}>

            <input type="radio" className="ww"  name="radioGroup"
                   checked={props.answerType === parseInt(props.answer, 10)}
                   id={props.answerType}
                   value={props.answerType}
                   disabled={props.answer}
                   onChange={props.onAnswerSelected}  />
            {props.answerContent}

        </label>
        </li>
    </div>
    <div className="clearfix"></div>
    </div>

        );

}

AnswerOption.propTypes = {
    answerType: React.PropTypes.number.isRequired,
    answerContent: React.PropTypes.string.isRequired,
    answer: React.PropTypes.number.isRequired,
    onAnswerSelected: React.PropTypes.func.isRequired
};

export default AnswerOption;



// WEBPACK FOOTER //
// ./react/app/components/AnswerOption.js